/* eslint react/prop-types: 0 */
import React from "react";
import { Link, withRouter } from "react-router-dom";

function PdfCard (props) {
  return (
    <div className="PdfCard card">
      <Link style={{ color: "black", textDecoration: "none" }} 
        to={`${props.match.params.refnum}.pdf`}
        target="_blank">
        <img src={props.preview} alt='pfd preview'/>
        <div className='downloadButton' >
          <h3>Download PDF</h3>
        </div>
      </Link>
    </div>
  );
}

export default withRouter(PdfCard);


// WEBPACK FOOTER //
// ./src/components/PdfCard/PdfCard.js